interface ConnectedSystemsFlowProps {
  compact?: boolean
  className?: string
}

const systems = [
  { name: 'CRM', detail: 'Accounts · deals', type: 'crm' },
  { name: 'Ads', detail: 'Engagement · spend', type: 'ads' },
  { name: 'Email', detail: 'Threads · replies', type: 'email' },
  { name: 'Calendar', detail: 'Meetings · commitments', type: 'calendar' },
  { name: 'Website', detail: 'Visits · intent', type: 'website' },
]

export function ConnectedSystemsFlow({ compact = false, className = '' }: ConnectedSystemsFlowProps) {
  return (
    <div
      className={`pp-system-flow${compact ? ' pp-system-flow--compact' : ''} ${className}`.trim()}
      aria-label="CRM, Ads, email, calendar, and website context connect through Ricald to coordinated work and decisions"
    >
      <div className="pp-system-flow__sources">
        {systems.map((system) => (
          <div className="pp-system-source" data-source={system.type} key={system.name}>
            <i aria-hidden="true" />
            <span><b>{system.name}</b><small>{system.detail}</small></span>
          </div>
        ))}
      </div>
      <div className="pp-system-flow__join" aria-hidden="true"><span>connected context</span></div>
      <div className="pp-system-core"><span>R</span><small>Ricald</small></div>
      <div className="pp-system-flow__split" aria-hidden="true" />
      <div className="pp-system-flow__outputs">
        <div><span>Work continues</span><b>Inside authority</b></div>
        <div><span>Decision for you</span><b>Reason attached</b></div>
      </div>
    </div>
  )
}

export default ConnectedSystemsFlow
